var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 86,
    viewBox: "0 0 71 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4259 60.4886C21.1129 60.4886 9.46851 48.8463 9.46851 34.5363C9.46851 20.2258 21.1129 8.5835 35.4259 8.5835C49.7387 8.5835 61.3832 20.2258 61.3832 34.5363C61.3832 48.8465 49.7387 60.4886 35.4259 60.4886Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.801 59.957V85.2021L35.426 75.7353L48.0507 85.2021V59.957H22.801Z",
    fill: "#E09500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8519 34.5367L65.3832 27.6967L67.3487 19.166L59.4468 15.388L57.5141 6.84448L48.7561 6.85434L43.3092 0L35.4258 3.82255L27.5422 0L22.0956 6.85434L13.3377 6.84448L11.4051 15.3878L3.50317 19.1657L5.46823 27.6967L0 34.5367L5.46823 41.3768L3.50317 49.9074L11.4051 53.6855L13.3377 62.229L22.0956 62.2191L27.5424 69.0735L35.426 65.2511L43.3094 69.0735L48.7561 62.2191L57.5139 62.2292L59.4468 53.6857L67.3485 49.9078L65.3832 41.3766L70.8519 34.5367ZM35.426 56.6213C23.227 56.6213 13.3377 46.7337 13.3377 34.5369C13.3377 22.3401 23.227 12.4528 35.426 12.4528C47.6252 12.4528 57.5143 22.3403 57.5143 34.5369C57.5141 46.7337 47.625 56.6213 35.426 56.6213Z",
    fill: "#43AD45"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4259 60.4886C21.1129 60.4886 9.46851 48.8463 9.46851 34.5363C9.46851 20.2258 21.1129 8.5835 35.4259 8.5835C49.7387 8.5835 61.3832 20.2258 61.3832 34.5363C61.3832 48.8465 49.7387 60.4886 35.4259 60.4886ZM35.4259 9.30523C21.5111 9.30523 10.1904 20.6237 10.1904 34.5363C10.1904 48.4484 21.5111 59.7671 35.4259 59.7671C49.3408 59.7671 60.6613 48.4484 60.6613 34.5363C60.6613 20.6237 49.3408 9.30523 35.4259 9.30523Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.fec18851599fcb62aed3445df682dd05.svg";
export { ForwardRef as ReactComponent };